import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/addOnServices`
    },
    addOnServicesAccountEligibility: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/addOnServices/accountEligibility`
    },
    getEpayAddOnStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/addOnServices/epay`
    },
    getAutomatedInvoiceEntryIntegrationEnabledAndProvisioned: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/addOnServices/automatedInvoiceEntry`
    },
    getAutomatedInvoiceEntryIntegrationEmailAddress: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/addOnServices/automatedInvoiceEntry/emailAddress`
    },
    enableAutomatedInvoiceEntryIntegration: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/addOnServices/automatedInvoiceEntry`
    },
    IsEligibleForObligo: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/obligo/eligibility`
    }
};

export function AddOnServicesSettingsApi() {
    return createActions(actions);
}
